/**
 * Additional Accessories block
 *
 * - Toggles tiles on click (multi-select)
 * - Keeps "Price with Selected Options" pill in sync with main variant +
 *   selected accessories
 * - On Add To Cart, submits the currently-selected main variant followed
 *   by each ticked accessory at the chosen qty (sequential /cart/add.js)
 */
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const dataEl = document.getElementById('accessories-main-data');
    if (!dataEl) return;

    const mainProductId = parseInt(dataEl.dataset.mainProductId, 10) || 0;
    const mainVariantIdInitial = parseInt(dataEl.dataset.mainVariantId, 10) || 0;
    const mainPriceCentsInitial = parseInt(dataEl.dataset.mainPriceCents, 10) || 0;
    const pricePillId = dataEl.dataset.pricePillId;
    const moneyFormat = dataEl.dataset.moneyFormat || '${{amount}}';

    // --- Extended warranty add-on ---
    const warrantyCheckbox = document.getElementById('ms-warranty-checkbox');
    const warrantyAmountEl = document.getElementById('ms-warranty-amount');
    const warrantyPercent = parseFloat(dataEl.dataset.warrantyPercent) || 0;
    const warrantyVariantId = parseInt(dataEl.dataset.warrantyVariantId, 10) || 0;
    const warrantyLabel = dataEl.dataset.warrantyLabel || 'Extended Warranty';
    let warrantyCents = (parseInt(dataEl.dataset.warrantyDollars, 10) || 0) * 100;

    // warranty $ = variant price x percent, rounded to whole dollars (the
    // $1.00 warranty product is added at quantity = this many dollars).
    function warrantyDollarsForPrice(priceCents) {
      return Math.round((priceCents * warrantyPercent) / 10000);
    }
    function updateWarranty() {
      if (!warrantyPercent) return;
      const { price } = readCurrentMainVariant();
      const dollars = warrantyDollarsForPrice(price);
      warrantyCents = dollars * 100;
      if (warrantyAmountEl) warrantyAmountEl.textContent = formatMoney(warrantyCents);
      if (window.MS_WARRANTY) {
        window.MS_WARRANTY.amountDollars = dollars;
        window.MS_WARRANTY.amountFormatted = formatMoney(warrantyCents);
      }
      syncWarrantySelected();
    }
    // Persist the tile's checked state onto window.MS_WARRANTY.selected AND into
    // a localStorage map keyed by product handle, so a multi-product quote can
    // list a warranty for each product the customer chose one on.
    function warrantyStoreGet() {
      try { return JSON.parse(localStorage.getItem('MS_WARRANTY_PICKS') || '{}') || {}; }
      catch (e) { return {}; }
    }
    function warrantyStoreSet(map) {
      try { localStorage.setItem('MS_WARRANTY_PICKS', JSON.stringify(map)); } catch (e) {}
    }
    function syncWarrantySelected() {
      if (!window.MS_WARRANTY) return;
      var checked = !!(warrantyCheckbox && warrantyCheckbox.checked);
      window.MS_WARRANTY.selected = checked;
      var handle = window.MS_WARRANTY.handle;
      if (!handle) return;
      var map = warrantyStoreGet();
      if (checked) {
        map[handle] = {
          handle: handle,
          title: window.MS_WARRANTY.parentTitle || '',
          amount: window.MS_WARRANTY.amountFormatted || ''
        };
      } else {
        delete map[handle];
      }
      warrantyStoreSet(map);
    }
    if (warrantyCheckbox) {
      warrantyCheckbox.addEventListener('change', function () {
        syncWarrantySelected();
        updatePricePill();
      });
    }
    syncWarrantySelected();

    // Learn More -> warranty details modal (product page only).
    var warrantyLearnBtn = document.getElementById('ms-warranty-learn');
    var warrantyModal = document.getElementById('ms-warranty-modal');
    if (warrantyLearnBtn && warrantyModal) {
      var openWarrantyModal = function () {
        warrantyModal.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      var closeWarrantyModal = function () {
        warrantyModal.hidden = true;
        document.body.style.overflow = '';
      };
      warrantyLearnBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openWarrantyModal();
      });
      warrantyModal.addEventListener('click', function (e) {
        if (e.target && e.target.hasAttribute('data-ms-wm-close')) closeWarrantyModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !warrantyModal.hidden) closeWarrantyModal();
      });
    }

    const qtyInput = document.getElementById('addon-qty');
    const addBtn = document.getElementById('addon-add-btn');
    const warnEl = document.getElementById('addon-qty-warning');

    if (!qtyInput || !addBtn) {
      console.warn('Accessories block: required DOM missing');
      return;
    }

    /* -------- helpers -------- */

    function formatMoney(cents) {
      // Minimal Shopify money_format support: {{amount}} / {{amount_no_decimals}}
      const dollars = (cents / 100).toFixed(2);
      const withCommas = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return moneyFormat
        .replace('{{amount}}', withCommas)
        .replace('{{ amount }}', withCommas)
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{ amount_no_decimals }}', noDecimals)
        .replace('{{amount_with_comma_separator}}', withCommas.replace(/,/g, ' ').replace('.', ','))
        .replace('{{ amount_with_comma_separator }}', withCommas.replace(/,/g, ' ').replace('.', ','));
    }

    // Read the currently selected main variant from variant-selects' JSON
    function readCurrentMainVariant() {
      const node = document.querySelector('variant-selects script[data-selected-variant]');
      if (!node) return { id: mainVariantIdInitial, price: mainPriceCentsInitial };
      try {
        const v = JSON.parse(node.textContent);
        return {
          id: v?.id ?? mainVariantIdInitial,
          price: typeof v?.price === 'number' ? v.price : mainPriceCentsInitial,
        };
      } catch (e) {
        return { id: mainVariantIdInitial, price: mainPriceCentsInitial };
      }
    }

    function selectedAccessories() {
      return Array.from(document.querySelectorAll('.accessories-block__grid .accessories-block__item.is-selected'))
        .map((el) => ({
          variantId: parseInt(el.dataset.variantId, 10) || 0,
          priceCents: parseInt(el.dataset.priceCents, 10) || 0,
          title: el.dataset.title || '',
        }))
        .filter((a) => a.variantId > 0);
    }

    // Required configuration (custom.required_configuration). Returns:
    //   null                      -> product has no config picker
    //   { missing: true }         -> picker shown but nothing chosen yet
    //   { none: true, ... }       -> customer chose "No <label>"
    //   { variantId, priceCents } -> customer chose an option
    const configEl = document.getElementById('ms-config');
    const configLabel = configEl ? (configEl.dataset.configLabel || 'Configuration') : '';
    function selectedConfig() {
      if (!configEl) return null;
      const picked = configEl.querySelector('.ms-config__item.is-selected');
      if (!picked) return { missing: true };
      const raw = picked.dataset.configVariantId || '';
      if (raw === 'none') return { none: true, variantId: 0, priceCents: 0, title: picked.dataset.title || 'None' };
      return {
        variantId: parseInt(raw, 10) || 0,
        priceCents: parseInt(picked.dataset.priceCents, 10) || 0,
        title: picked.dataset.title || '',
      };
    }

    // Returns one selected gift per active free-gift section (radio group
    // keyed by data-free-gift-promo). If a section is rendered but nothing
    // is picked, the missing entry is included with variantId=0 so the
    // validator can flag it.
    function selectedFreeGifts() {
      const sections = document.querySelectorAll('.free-gift-block');
      return Array.from(sections).map((section) => {
        const promo = section.dataset.freeGiftPromo || '';
        const picked = section.querySelector('.free-gift-block__item.is-selected');
        return {
          promo: promo,
          variantId: picked ? (parseInt(picked.dataset.freeGiftVariantId, 10) || 0) : 0,
          title: picked ? (picked.dataset.freeGiftTitle || '') : '',
        };
      });
    }

    function updatePricePill() {
      updateWarranty();
      if (!pricePillId) return;
      const pill = document.getElementById(pricePillId);
      if (!pill) return;

      // The price pill in the theme has a single bolded element holding the
      // formatted price. Find the inner money node by class, fall back to the
      // last strong-ish span inside the pill.
      let priceEl = pill.querySelector('[data-accessories-price-target]');
      if (!priceEl) {
        // Heuristic: the element whose text currently contains a currency sign
        const candidates = pill.querySelectorAll('span, div');
        for (const c of candidates) {
          if (/[$€£¥]/.test(c.textContent) && !c.classList.contains('line-through')) {
            priceEl = c;
            break;
          }
        }
      }
      if (!priceEl) return;

      const { price: mainPrice } = readCurrentMainVariant();
      const accTotal = selectedAccessories().reduce((s, a) => s + a.priceCents, 0);
      const cfg = selectedConfig();
      const cfgTotal = cfg && !cfg.missing ? cfg.priceCents : 0;
      const warrantyTotal = warrantyCheckbox && warrantyCheckbox.checked ? warrantyCents : 0;
      priceEl.textContent = formatMoney(mainPrice + accTotal + cfgTotal + warrantyTotal);
    }

    /* -------- tile toggle (accessories: multi-select, optional cap) -------- */

    // custom.accessories_max_select -> data-max-select on the grid. 0 = no cap.
    // Only TOP-LEVEL tiles count toward the cap; nested sub-accessories (e.g. a
    // rotor's adapters) don't. Picking past the cap swaps out the OLDEST pick,
    // so a cap of 1 behaves like a radio button.
    const accGrid = document.querySelector('.accessories-block__grid');
    const maxSelect = accGrid ? (parseInt(accGrid.dataset.maxSelect, 10) || 0) : 0;
    const pickOrder = []; // top-level tiles, oldest first

    function isNestedTile(tile) {
      return tile.classList.contains('accessories-block__item--nested');
    }

    function setTileSelected(tile, on) {
      tile.classList.toggle('is-selected', on);
      tile.setAttribute('aria-pressed', on ? 'true' : 'false');

      // Accessories that themselves have their own accessories (e.g. a
      // rotor with rotor adapters) render a hidden subgroup right after
      // their tile. Selecting the parent reveals it; deselecting hides
      // it again and clears out anything picked inside, so a hidden pick
      // never counts toward the price pill or gets added to cart.
      const subgroup = tile.nextElementSibling;
      if (subgroup && subgroup.classList.contains('accessories-block__subgroup')) {
        subgroup.hidden = !on;
        if (!on) {
          subgroup.querySelectorAll('.accessories-block__item.is-selected').forEach((child) => {
            child.classList.remove('is-selected');
            child.setAttribute('aria-pressed', 'false');
          });
        }
      }

      if (isNestedTile(tile)) return;
      const idx = pickOrder.indexOf(tile);
      if (idx !== -1) pickOrder.splice(idx, 1);
      if (on) pickOrder.push(tile);
    }

    document.querySelectorAll('.accessories-block__grid .accessories-block__item').forEach((tile) => {
      tile.addEventListener('click', (e) => {
        if (tile.hasAttribute('disabled')) return;
        e.preventDefault();
        const next = !tile.classList.contains('is-selected');
        setTileSelected(tile, next);

        // Over the cap -> drop the oldest top-level pick(s).
        if (next && maxSelect > 0 && !isNestedTile(tile)) {
          while (pickOrder.length > maxSelect) {
            setTileSelected(pickOrder[0], false);
          }
        }

        updatePricePill();
      });
    });

    /* -------- required configuration: single-select, can't be un-picked -------- */

    if (configEl) {
      const cfgTiles = configEl.querySelectorAll('.ms-config__item');
      const cfgError = document.getElementById('ms-config-error');
      cfgTiles.forEach((tile) => {
        tile.addEventListener('click', (e) => {
          if (tile.hasAttribute('disabled')) return;
          e.preventDefault();
          cfgTiles.forEach((t) => {
            t.classList.remove('is-selected');
            t.setAttribute('aria-checked', 'false');
          });
          tile.classList.add('is-selected');
          tile.setAttribute('aria-checked', 'true');
          configEl.classList.remove('is-missing-selection');
          if (cfgError) cfgError.hidden = true;
          // Keep the Quotify bridge in sync so the quote form starts on the
          // same choice ('none' or the variant id).
          if (window.MS_CONFIGURATION) {
            window.MS_CONFIGURATION.selectedVariantId = tile.dataset.configVariantId || null;
          }
          updatePricePill();
        });
      });
    }

    /* -------- tile toggle (free gifts: single-select per section) -------- */

    document.querySelectorAll('.free-gift-block').forEach((section) => {
      const tiles = section.querySelectorAll('.free-gift-block__item');
      tiles.forEach((tile) => {
        tile.addEventListener('click', (e) => {
          if (tile.hasAttribute('disabled')) return;
          e.preventDefault();
          const wasSelected = tile.classList.contains('is-selected');
          // Clear selection across the whole radio group (this section).
          tiles.forEach((t) => {
            t.classList.remove('is-selected');
            t.setAttribute('aria-checked', 'false');
          });
          if (!wasSelected) {
            tile.classList.add('is-selected');
            tile.setAttribute('aria-checked', 'true');
          }
          // Free gifts contribute $0 to the running total, so no pill update.
          // Clear any prior validation flag.
          section.classList.remove('is-missing-selection');
        });
      });
    });

    /* -------- keep pill correct when variant changes -------- */
    // The theme's product-info.js re-renders #price-{sectionId} on variant
    // change, which wipes our accessory-adjusted total. Re-apply after each
    // variant change so the tally is preserved.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      try {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
          // Wait a tick for DOM swap to finish
          setTimeout(updatePricePill, 30);
        });
      } catch (_) { /* no-op */ }
    }
    // Fallback: also listen on the bubbling change event inside variant-selects
    document.addEventListener('change', (event) => {
      if (event.target.closest('variant-selects')) {
        // product-info.js does an async fetch before replacing innerHTML,
        // so re-apply a couple of times to catch it.
        setTimeout(updatePricePill, 300);
        setTimeout(updatePricePill, 900);
      }
    });

    /* -------- qty validation -------- */

    function validateQty() {
      const qty = parseInt(qtyInput.value, 10) || 0;
      if (qty < 1) {
        warnEl.textContent = 'Quantity must be at least 1.';
        addBtn.disabled = true;
        addBtn.classList.add('opacity-50', 'cursor-not-allowed');
        return false;
      }
      warnEl.textContent = '';
      addBtn.disabled = false;
      addBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      return true;
    }
    qtyInput.addEventListener('input', validateQty);

    /* -------- add to cart -------- */

    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!validateQty()) return;
      const qty = parseInt(qtyInput.value, 10) || 1;

      // Free gift: each rendered section requires exactly one selection.
      const freeGiftPicks = selectedFreeGifts();
      const missingGiftSections = freeGiftPicks.filter((g) => !g.variantId);
      if (missingGiftSections.length > 0) {
        const sections = document.querySelectorAll('.free-gift-block');
        sections.forEach((s) => {
          const promo = s.dataset.freeGiftPromo || '';
          const isMissing = missingGiftSections.some((m) => m.promo === promo);
          s.classList.toggle('is-missing-selection', isMissing);
        });
        warnEl.textContent = 'Please select your free gift.';
        const firstMissing = document.querySelector('.free-gift-block.is-missing-selection');
        if (firstMissing && firstMissing.scrollIntoView) {
          firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      // Required configuration must be chosen (an option or "None").
      const cfgPick = selectedConfig();
      if (cfgPick && cfgPick.missing) {
        configEl.classList.add('is-missing-selection');
        const cfgError = document.getElementById('ms-config-error');
        if (cfgError) cfgError.hidden = false;
        warnEl.textContent = 'Please select a ' + configLabel.toLowerCase() + ' option.';
        if (configEl.scrollIntoView) configEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const { id: mainId } = readCurrentMainVariant();
      if (!mainId) {
        alert('Main product variant not found.');
        return;
      }

      const mainLine = { id: mainId, quantity: qty };
      // Record the chosen configuration on the main line so it's visible on
      // the cart + order (e.g. "Sample Block: None (instrument only)").
      if (cfgPick && !cfgPick.missing) {
        mainLine.properties = {};
        mainLine.properties[configLabel] = cfgPick.none ? 'None (instrument only)' : cfgPick.title;
      }
      const queue = [mainLine];
      if (cfgPick && !cfgPick.missing && !cfgPick.none && cfgPick.variantId > 0) {
        queue.push({
          id: cfgPick.variantId,
          quantity: qty,
          properties: {
            '_parent_product_id': String(mainProductId),
            '_configuration': '1',
          },
        });
      }
      selectedAccessories().forEach((a) => {
        // Tag each accessory line with the parent product id so the cart
        // cleanup script can auto-remove it if the parent is removed.
        queue.push({
          id: a.variantId,
          quantity: qty,
          properties: { '_parent_product_id': String(mainProductId) },
        });
      });
      // Free gift: queue one per section, qty matches main qty (so 2 parents
      // → 2 gifts). Tag with parent id so cart cleanup removes it when the
      // parent line is deleted.
      freeGiftPicks.forEach((g) => {
        if (!g.variantId) return;
        queue.push({
          id: g.variantId,
          quantity: qty,
          properties: {
            '_parent_product_id': String(mainProductId),
            '_free_gift_promo': g.promo,
          },
        });
      });

      // Extended warranty: add the $1.00 "Extended Warranty" product at
      // quantity = warranty dollars (x main qty) so the line total equals the
      // warranty price. Tagged with the parent id so cart cleanup removes it
      // if the main product is taken out of the cart.
      if (warrantyCheckbox && warrantyCheckbox.checked && warrantyVariantId > 0) {
        updateWarranty();
        const warrantyDollars = Math.round(warrantyCents / 100);
        if (warrantyDollars > 0) {
          queue.push({
            id: warrantyVariantId,
            quantity: warrantyDollars * qty,
            properties: {
              '_warranty': '1',
              '_parent_product_id': String(mainProductId),
              'Coverage': warrantyLabel + ' \u2014 ' + (dataEl.dataset.mainTitle || 'item'),
            },
          });
        }
      }

      addBtn.disabled = true;
      const origHTML = addBtn.innerHTML;
      addBtn.innerHTML = 'Adding...';

      for (const line of queue) {
        try {
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(line),
          });
          if (!resp.ok) {
            const body = await resp.json().catch(() => ({}));
            alert(body.description || body.message || 'Failed to add item');
            addBtn.innerHTML = origHTML;
            addBtn.disabled = false;
            return;
          }
          await new Promise((r) => setTimeout(r, 150));
        } catch (err) {
          console.error(err);
          alert('Network error while adding to cart.');
          addBtn.innerHTML = origHTML;
          addBtn.disabled = false;
          return;
        }
      }

      window.location.href = '/cart';
    });

    /* -------- collapsible grid toggle -------- */

    const toggleBtn = document.querySelector('[data-accessories-toggle]');
    if (toggleBtn) {
      const grid = document.querySelector('.accessories-block__grid--collapsible');
      const labelMore = toggleBtn.querySelector('[data-toggle-text-more]');
      const labelLess = toggleBtn.querySelector('[data-toggle-text-less]');
      toggleBtn.addEventListener('click', () => {
        const wasCollapsed = grid.classList.contains('is-collapsed');
        grid.classList.toggle('is-collapsed', !wasCollapsed);
        toggleBtn.setAttribute('aria-expanded', wasCollapsed ? 'true' : 'false');
        if (labelMore && labelLess) {
          labelMore.hidden = wasCollapsed;
          labelLess.hidden = !wasCollapsed;
        }
      });
    }

    /* -------- init -------- */
    updatePricePill();
    validateQty();
  });
})();
